export default __webpack_public_path__ + "static/media/AndresOlarte.0b566e29.jpeg";